export const STATUS = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  L1_PENDING: "L1_PENDING",
  L1_APPROVED: "L1_APPROVED",
  L1_REJECTED: "L1_REJECTED",
  L2_PENDING: "L2_PENDING",
  L2_APPROVED: "L2_APPROVED",
  L2_REJECTED: "L2_REJECTED",
}
export enum RoleType {
  REQUESTER = 'REQUESTER',
  L1 = 'L1',
  L2 = 'L2',
}
export const ROLE_MAP: Record<string, string> = {
  REQUESTER: 'Store Requester',
  L1: 'Store L1 Approver',
  L2: 'Store L2 Approver',
}
export enum RequestAction {
  APPROVE = 'approve',
  REJECT = 'reject',
}
export const DEFAULT_ROLE = 'FRM'
